import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ItemDetailProvider } from "@/lib/itemDetail";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import InventoryAdvisor from "@/pages/InventoryAdvisor";
import BulkItemLookup from "@/pages/BulkItemLookup";
import LeadTimeManager from "@/pages/LeadTimeManager";
import DataUpload from "@/pages/DataUpload";
import Settings from "@/pages/Settings";
import ProcurementSnapshot from "@/pages/ProcurementSnapshot";
import PreferredSupplier from "@/pages/PreferredSupplier";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";

function Shell() {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen grid place-items-center text-slate-400 text-sm">Loading…</div>;
  if (!user) return <Login />;
  return (
    <ItemDetailProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/advisor" element={<InventoryAdvisor />} />
          <Route path="/bulk" element={<BulkItemLookup />} />
          <Route path="/procurement" element={<ProcurementSnapshot />} />
          <Route path="/preferred-supplier" element={<PreferredSupplier />} />
          <Route path="/lead-times" element={<LeadTimeManager />} />
          <Route path="/upload" element={<DataUpload />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/users" element={<Users />} />
          <Route path="/audit" element={<Audit />} />
        </Routes>
      </Layout>
    </ItemDetailProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
